import axios from 'axios';
import Helper from '@/helper';
import itemApi from '@/api/item';

export default {
  // Warehouses
  async getWarehouses() {
    return axios({ url: '/api/tenant/inventory/warehouses' }).then(r => r.data);
  },

  async createWarehouse(data) {
    return axios({
      url: '/api/tenant/inventory/warehouses',
      method: 'post',
      data,
    }).then(r => r.data);
  },

  async updateWarehouse(id, data) {
    return axios({
      url: '/api/tenant/inventory/warehouses/' + id,
      method: 'put',
      data,
    }).then(r => r.data);
  },

  async deleteWarehouse(id) {
    return axios({
      url: '/api/tenant/inventory/warehouses/' + id,
      method: 'delete',
    }).then(r => r.data);
  },

  // Warehouse balance operations
  async recalculateBalances() {
    return axios({
      url: '/api/tenant/inventory/balances/recalculate',
      method: 'post',
    }).then(r => r.data);
  },

  async getWarehouseBalances(warehouseId) {
    return axios({ url: '/api/tenant/inventory/balances/warehouse', params: { warehouseId } }).then(r => r.data);
  },

  // accountingClass: kirjanpidollisen luokan avain, undefined = kaikki. Tiedostonimessä on luokka ja päivä.
  async getWarehouseSnapshot(date, typeIds, warehouseId, accountingClass) {
    const response = await axios({
      url: '/api/tenant/inventory/balances/warehouse/snapshot',
      params: { date, typeIds: typeIds ? typeIds.join(',') : undefined, warehouseId, accountingClass },
      responseType: 'blob',
    });
    const match = /filename="?([^";]+)"?/.exec(response.headers['content-disposition'] || '');
    return { blob: response.data, filename: match ? match[1] : `varastosaldo_${date}.xlsx` };
  },

  async getSiteBalances(siteId) {
    return axios({ url: '/api/tenant/inventory/balances/site/' + siteId }).then(r => r.data);
  },

  async getItemBalances(itemId) {
    return axios({ url: '/api/tenant/inventory/balances/item/' + itemId }).then(r => r.data);
  },

  async getWarehouseBalanceForItem(itemId, warehouseId) {
    return axios({ url: '/api/tenant/inventory/balances/warehouse/item/' + itemId, params: { warehouseId } }).then(r => r.data);
  },

  // Transaction operations
  async addToWarehouse(data) {
    itemApi.clearCache();
    return axios({
      url: '/api/tenant/inventory/transactions/add',
      method: 'post',
      data,
    }).then(r => r.data);
  },

  async removeFromWarehouse(data) {
    return axios({
      url: '/api/tenant/inventory/transactions/remove',
      method: 'post',
      data,
    }).then(r => r.data);
  },

  async adjustBalance(data) {
    return axios({
      url: '/api/tenant/inventory/transactions/adjust',
      method: 'post',
      data,
    }).then(r => r.data);
  },

  async transferBetweenWarehouses(data) {
    return axios({
      url: '/api/tenant/inventory/transactions/transfer',
      method: 'post',
      data,
    }).then(r => r.data);
  },

  async getItemTransactionHistory(itemId, description, warehouseId) {
    return axios({ url: '/api/tenant/inventory/transactions/item/' + itemId, params: { description, warehouseId } }).then(r => r.data);
  },

  async getSiteTransactionHistory(siteId) {
    return axios({ url: '/api/tenant/inventory/transactions/site/' + siteId }).then(r => r.data);
  },

  async getWarehouseTransactionHistory(description, warehouseId) {
    return axios({ url: '/api/tenant/inventory/transactions/warehouse', params: { description, warehouseId } }).then(r => r.data);
  },

  // filter: { description, warehouseId, itemId, from, to }; options: v-data-table options
  async getWarehouseTransactionHistoryPaged(filter, options) {
    return axios({
      url: '/api/tenant/inventory/transactions/warehouse/paged',
      params: { ...Helper.tableOptionsToRestPageParams(options), ...filter },
    }).then(r => r.data);
  },

  async getWarehouseTransactionHistoryExcel(from, to, warehouseId) {
    return axios({
      url: '/api/tenant/inventory/transactions/warehouse/excel',
      params: { from, to, warehouseId },
      responseType: 'blob',
    }).then(r => r.data);
  },

  // Dispatch note operations
  async createDispatchNote(data) {
    return axios({
      url: '/api/tenant/inventory/dispatch-notes',
      method: 'post',
      data,
    }).then(r => r.data);
  },

  async completeDispatchNote(id) {
    return axios({
      url: '/api/tenant/inventory/dispatch-notes/' + id + '/complete',
      method: 'post',
    }).then(r => r.data);
  },

  async getDispatchNote(id) {
    return axios({ url: '/api/tenant/inventory/dispatch-notes/' + id }).then(r => r.data);
  },

  async getSiteDispatchNotes(siteId) {
    return axios({ url: '/api/tenant/inventory/dispatch-notes/site/' + siteId }).then(r => r.data);
  },

  async getAllDispatchNotes() {
    return axios({ url: '/api/tenant/inventory/dispatch-notes' }).then(r => r.data);
  },

  async deleteDispatchNote(id) {
    return axios({
      url: '/api/tenant/inventory/dispatch-notes/' + id,
      method: 'delete',
    }).then(r => r.data);
  },

  async deleteTransaction(id) {
    return axios({
      url: '/api/tenant/inventory/transactions/' + id,
      method: 'delete',
    }).then(r => r.data);
  },

  async updateTransaction(id, data) {
    return axios({
      url: '/api/tenant/inventory/transactions/' + id,
      method: 'put',
      data,
    }).then(r => r.data);
  },

  async updateDispatchNote(id, data) {
    return axios({
      url: '/api/tenant/inventory/dispatch-notes/' + id,
      method: 'put',
      data,
    }).then(r => r.data);
  },

  async updateCompletedDispatchNote(id, data) {
    return axios({
      url: '/api/tenant/inventory/dispatch-notes/' + id + '/completed',
      method: 'put',
      data,
    }).then(r => r.data);
  },
};
